<template>
  <svg
    width="8px"
    height="8px"
    viewBox="0 0 8 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="icon"
  >
    <title>61C87E0F-DD1B-41EC-ACD7-99E0FDB3FF85</title>
    <g id="Design-System" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="DesignSystem" transform="translate(-1029.000000, -15080.000000)" fill="#121212">
        <g id="Group-4" transform="translate(1029.000000, 15080.000000)">
          <circle id="Oval" cx="1" cy="1" r="1"></circle>
          <circle id="Oval" cx="4" cy="1" r="1"></circle>
          <circle id="Oval" cx="7" cy="1" r="1"></circle>
          <circle id="Oval" cx="1" cy="4" r="1"></circle>
          <circle id="Oval" cx="4" cy="4" r="1"></circle>
          <circle id="Oval" cx="7" cy="4" r="1"></circle>
          <circle id="Oval" cx="1" cy="7" r="1"></circle>
          <circle id="Oval" cx="4" cy="7" r="1"></circle>
          <circle id="Oval" cx="7" cy="7" r="1"></circle>
        </g>
      </g>
    </g>
  </svg>
</template>
